import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple, DemoContent, TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import Formsy from 'formsy-react';
import { Button, FormControlLabel, TextField, Hidden, MenuItem, Radio, Icon, Checkbox, Typography, IconButton } from 'material-ui';
import ReactTable from "react-table";
import axios from 'axios';
import { bindActionCreators } from 'redux';
import { Tab, Tabs } from 'material-ui';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import $ from "jquery";
import { withAlert } from 'react-alert';
import Tooltip from 'material-ui/Tooltip';

const styles = theme => ({
    layoutRoot: {}
});

var editEmpId = null;
var editEmpRegId = null;
var editNic = null;
var editFirstName = null;
var editAddress1 = null;
var editAddress2 = null;
var editMobile = null;
var editEmail = null;
var editTelephone = null;
var editFax = null;
var editState = null;
var editCity = null;
var editZipCode = null;
var editCountryCode = null;

var deleteEmpId = null;
var deleteFirstName = null;

class Tab2LoadEmployeeContactDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            data: []
        };

        this.loadEmployeeContactDetails();
    }

    // Edit Statement
    stateEdit = {
        canEdit: false
    };

    handleClickOpenEdit = () => {
        this.setState({ edit: true });
    };

    handleCloseEdit = () => {
        this.setState({ edit: false });
    };

    addhandleClickOpen = () => {
        this.setState({ add: true });
    };

    addhandleClose = () => {
        this.setState({ add: false });
    };

    disableButton = () => {
        this.setState({ canSubmit: false });
    };

    enableButton = () => {
        this.setState({ canSubmit: true });
    };

    // edit employee personal details
    onEdit = (model) => {

        this.editEmployeeContactDetail(model);
    };

    onDelete = (model) => {
        this.deleteEmployeeContactDetail(model);
    };

    disableButtonDelete = () => {
        this.setState({ canEdit: false });
    };

    enableButtonDelete = () => {
        this.setState({ canEdit: true });
    };

    // Delete Statement
    handleClickDelete = () => {
        // alert(e.value);
        this.setState({ delete: true });
    };

    handleCloseDelete = () => {
        this.setState({ delete: false });
    };

    stateDelete = {
        canDelete: false
    };

    // load employee contact details
    loadEmployeeContactDetails() {

        axios.get(window.hrmServer + '/getEmployeeDetails')
            .then(response => {
                if (response.data.success) {
                    // alert('Success');
                    var employeeObj = response.data.result;

                    this.appendToTable(employeeObj);
                }
            });

        this.handleCloseEdit();
    }

    // append data into table
    appendToTable(employeeObj) {
        var data = [];
        // console.log("peeen " + employeeObj[31].PROFILE_IMAGE);

        for (var i = 0; i < employeeObj.length; i++) {

            data.push({

                empId: employeeObj[i].ID_EMPLOYEE_PROFILE,
                editEmpRegId: employeeObj[i].ID_EMPLOYEE_REGISTRY,
                firstName: employeeObj[i].FIRST_NAME,
                address1: employeeObj[i].ADDRESS1,
                address2: employeeObj[i].ADDRESS2,
                nic: employeeObj[i].NIC,
                mobile: employeeObj[i].MOBILE_CONTACT,
                email: employeeObj[i].EMAIL,
                telephone: employeeObj[i].TELEPHONE_CONTACT,
                fax: employeeObj[i].FAX,
                state: employeeObj[i].STATE,
                city: employeeObj[i].CITY,
                zipCode: employeeObj[i].ZIP_CODE,
                countryCode: employeeObj[i].COUNTRY_CODE
            });

        }
        this.setState({ data: data });
    }

    // update employee contact details
    editEmployeeContactDetail(model) {

        var editEmpContactDetail = {
            editEmpId: model.editEmpId,
            editAddress1: model.editAddress1,
            editAddress2: model.editAddress2,
            editMobile: model.editMobile,
            editEmail: model.editEmail,
            editTelephone: model.editTelephone,
            editFax: model.editFax,
            editState: model.editState,
            editCity: model.editCity,
            editZipCode: model.editZipCode,
            editCountryCode: model.editCountryCode
        }

        // neeed to create edit employee persnol data servise
        axios.post(window.hrmServer + '/editEmployeeContactDatail', editEmpContactDetail)
            .then(res => {

                // alert(res.data.success);
                if (res.data.success) {

                    this.props.alert.success("Contact Details Updated Successfully");

                    this.handleCloseEdit();
                    this.loadEmployeeContactDetails();
                } else {
                    this.props.alert.error("Unable to Updated Please Check !");
                }
            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                this.props.alert.error("No internet connection or Internal error");
            });

    }

    // delete contact details employee details 
    deleteEmployeeContactDetail(model) {
        var employeeId = model.deleteEmpId;

        if (null == employeeId || "" == employeeId || undefined == employeeId) {

            this.props.alert.error("Cannot Delete This Contact Detail !");

        } else {

            var deleteObj = {
                employeeId: employeeId
            }

            axios.post(window.hrmServer + '/deleteEmployee', deleteObj)
                .then(response => {

                    if (response.data.success) {

                        this.props.alert.success("Contact Detail Deleted Successfully");

                        this.handleCloseDelete();
                        this.loadEmployeeContactDetails();
                    } else {

                        this.props.alert.error("Unable to Deleted Please Check !");
                    }

                }).catch(function (error) {
                    alert("Error");
                    console.log("No internet connection or Internal error");
                    this.props.alert.error("No internet connection or Internal error !");
                });
        }
    }

    render() {
        return (

            <div className="w-full">
                <ReactTable className="w-full"
                    getTrProps={(state, rowInfo, column) => {
                        return {
                            className: "cursor-pointer",
                            onClick: (e, handleOriginal) => {

                            }
                        }
                    }}
                    data={this.state.data}
                    columns={[

                        {
                            Header: "Emp Id",
                            accessor: "empId",
                            show: false
                        },

                        {
                            Header: "EditEmpRegId",
                            accessor: "editEmpRegId",
                            show: false
                        },

                        {
                            Header: "First Name",
                            accessor: "firstName",
                            show: false
                        },

                        {
                            Header: "NIC No",
                            accessor: "nic",
                            filterable: true
                        },
                        {
                            Header: "Address 1",
                            accessor: "address1",
                            filterable: true
                        },
                        {
                            Header: "Address 2",
                            accessor: "address2",
                            filterable: true

                        },
                        {
                            Header: "Mobile",
                            accessor: "mobile",
                            filterable: true

                        },
                        {
                            Header: "Email",
                            accessor: "email",
                            filterable: true

                        },
                        {
                            Header: "Teleohone",
                            accessor: "telephone",
                            filterable: true

                        },
                        // {
                        //     Header: "Fax",
                        //     accessor: "fax",
                        //     filterable: true

                        // },
                        // {
                        //     Header: "State",
                        //     accessor: "state",
                        //     filterable: true

                        // },
                        {
                            Header: "City",
                            accessor: "city",
                            filterable: true

                        },
                        // {
                        //     Header: "Zip Code",
                        //     accessor: "zipCode",
                        //     filterable: true

                        // },
                        // {
                        //     Header: "Country Code",
                        //     accessor: "countryCode",
                        //     filterable: true,
                        //     width:150

                        // },

                        {
                            Header: "Action",
                            // accessor: "su",
                            width: 128,
                            Cell: row => (
                                <div className="flex items-center w-8 h-8">

                                    <Tooltip
                                        enterDelay={300}
                                        id="tooltip-controlled"
                                        leaveDelay={300}
                                        onClose={this.handleTooltipClose}
                                        onOpen={this.handleTooltipOpen}
                                        open={this.state.open}
                                        placement="bottom"
                                        title="Edit contact details"
                                    >
                                        <IconButton

                                            onClick={(e) => {
                                                if (row) {

                                                    editEmpId = row.original.empId;
                                                    editEmpRegId = row.original.editEmpRegId;
                                                    editNic = row.original.nic;
                                                    editFirstName = row.original.firstName;
                                                    editAddress1 = row.original.address1;
                                                    editAddress2 = row.original.address2;
                                                    editMobile = row.original.mobile;
                                                    editEmail = row.original.email;
                                                    editTelephone = row.original.telephone;
                                                    editFax = row.original.fax;
                                                    editState = row.original.state;
                                                    editCity = row.original.city;
                                                    editZipCode = row.original.zipCode;
                                                    editCountryCode = row.original.countryCode;

                                                    this.setState({ edit: true });
                                                }
                                            }}

                                        >
                                            <Icon className="text-blue">mode_edit</Icon>
                                        </IconButton>
                                    </Tooltip>

                                    {/* ///// */}

                                    <Dialog

                                        open={this.state.edit}
                                        onClose={this.handleCloseEdit}
                                        aria-labelledby="form-dialog-title"
                                    >
                                        <Formsy
                                            onValidSubmit={this.onEdit}
                                            onValid={this.enableButtonEdit}
                                            onInvalid={this.disableButtonEdit}
                                            ref={(form) => this.form = form}
                                            className=""
                                        >
                                            <DialogTitle id="form-dialog-title">Edit Contact Details</DialogTitle>
                                            <DialogContent className="flex flex-wrap">

                                                <div className="w-full">

                                                    <TextFieldFormsy
                                                        type="hidden"
                                                        name="editEmpId"
                                                        value={editEmpId}
                                                    />

                                                    <TextFieldFormsy
                                                        className="w-1/3 pr-8"
                                                        type="text"
                                                        name="editEmpCode"
                                                        label="Employee ID"
                                                        value={'EMP' + editEmpRegId}
                                                        required
                                                        disabled={true}
                                                    />

                                                    <TextFieldFormsy
                                                        className="w-1/3 pr-8"
                                                        type="text"
                                                        name="editNic"
                                                        label="NIC No"
                                                        value={editNic}
                                                        disabled={true}
                                                    />

                                                    <TextFieldFormsy
                                                        className="w-1/3"
                                                        type="text"
                                                        name="editFirstName"
                                                        label="First Name"
                                                        value={editFirstName}
                                                        disabled={true}
                                                    />
                                                </div>

                                                <div className="w-full">
                                                    <TextFieldFormsy
                                                        className="w-full mt-16"
                                                        type="text"
                                                        name="editAddress1"
                                                        label="Address 1"
                                                        value={editAddress1}
                                                        required
                                                    // disabled={true}
                                                    />
                                                </div>

                                                <div className="w-full">
                                                    <TextFieldFormsy
                                                        className="w-full mt-16"
                                                        type="text"
                                                        name="editAddress2"
                                                        label="Address 2"
                                                        value={editAddress2}
                                                    // required
                                                    // disabled={true}
                                                    />
                                                </div>

                                                <div className="w-full">
                                                    <TextFieldFormsy
                                                        className="w-1/2 pr-8 mt-16"
                                                        type="text"
                                                        name="editMobile"
                                                        label="Mobile"
                                                        value={editMobile}
                                                        required
                                                    // disabled={true}
                                                    />

                                                    <TextFieldFormsy
                                                        className="w-1/2 mt-16"
                                                        type="text"
                                                        name="editEmail"
                                                        label="Email"
                                                        value={editEmail}
                                                        validations="isEmail"
                                                        validationError="This is not a valid email"
                                                    />
                                                </div>

                                                <div className="w-full">
                                                    <TextFieldFormsy
                                                        className="w-1/2 pr-8 mt-16"
                                                        type="text"
                                                        name="editTelephone"
                                                        label="Telephone"
                                                        value={editTelephone}
                                                    // disabled={true}
                                                    />

                                                    <TextFieldFormsy
                                                        className="w-1/2 mt-16"
                                                        type="text"
                                                        name="editFax"
                                                        label="Fax"
                                                        value={editFax}
                                                    // disabled={true}
                                                    />
                                                </div>

                                                <div className="w-full">
                                                    <TextFieldFormsy
                                                        className="w-1/4 pr-8 mt-16"
                                                        type="text"
                                                        name="editState"
                                                        label="State"
                                                        value={editState}
                                                    // disabled={true}
                                                    />

                                                    <TextFieldFormsy
                                                        className="w-1/4 pr-8 mt-16"
                                                        type="text"
                                                        name="editCity"
                                                        label="City"
                                                        value={editCity}
                                                    // disabled={true}
                                                    />

                                                    <TextFieldFormsy
                                                        className="w-1/4 pr-8 mt-16"
                                                        type="text"
                                                        name="editZipCode"
                                                        label="Zip Code"
                                                        value={editZipCode}
                                                    // disabled={true}
                                                    />

                                                    <TextFieldFormsy
                                                        className="w-1/4 mt-16"
                                                        type="text"
                                                        name="editCountryCode"
                                                        label="Country Code"
                                                        value={editCountryCode}
                                                    // disabled={true}
                                                    />
                                                </div>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button type="button" onClick={this.handleCloseEdit} variant="raised" size="small" color="primary" className="{classes.button} w-full  md:h-24">
                                                    Close
                                                    </Button>

                                                <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:h-24 ">
                                                    Update
                                                    </Button>
                                            </DialogActions>
                                        </Formsy>
                                    </Dialog>
                                    {/* ///// */}


                                    {/* <IconButton
                                        onClick={(e) => {
                                            if (row) {

                                                deleteEmpId = row.original.empId;
                                                deleteFirstName = row.original.firstName;
                                                // deleteLastName = row.original.lastName;
                                                this.setState({ delete: true });
                                            }
                                        }}
                                    >
                                        <Icon className="text-red-light">delete</Icon>
                                    </IconButton> */}


                                    {/* ///// */}

                                    {/* <Dialog
                                        open={this.state.delete}
                                        onClose={this.handleClose}
                                        aria-labelledby="form-dialog-title"
                                    >
                                        <DialogTitle id="form-dialog-title">Delete Employee</DialogTitle>
                                        <DialogContent>

                                            <div>
                                                <Formsy
                                                    onValidSubmit={this.onDelete}
                                                    onValid={this.enableButtonDelete}
                                                    onInvalid={this.disableButtonDelete}
                                                    ref={(form) => this.form = form}
                                                    className="flex flex-col justify-center"
                                                >
                                                    <TextFieldFormsy
                                                        type="hidden"
                                                        name="deleteEmpId"
                                                        value={deleteEmpId}
                                                    />

                                                    <div className="w-full">
                                                        Are you sure delete <h4>{deleteFirstName +" ?"}</h4>
                                                    </div>

                                                    <DialogActions>
                                                        <Button onClick={this.handleCloseDelete} color="primary">
                                                            Cancel
                                                                </Button>
                                                        <Button color="primary" autoFocus
                                                            type="submit"
                                                        >
                                                            Delete
                                                        </Button>

                                                    </DialogActions>
                                                </Formsy>
                                            </div>
                                        </DialogContent>


                                    </Dialog> */}

                                    {/* ///// */}


                                </div>
                            )
                        }

                    ]}
                    defaultPageSize={10}
                    className="-striped -highlight"
                />

            </div>

        );
    }
}

export default withStyles(styles, { withTheme: true })(withAlert(Tab2LoadEmployeeContactDetails));



// WEBPACK FOOTER //
// ./src/main/content/hr/viewEmployee/components/Tab2LoadEmployeeContactDetails.js